// Lightweight Google Analytics (GA4) loader with GDPR-friendly consent gating:
// the gtag.js script is only injected AFTER the visitor explicitly accepts
// cookies (see CookieConsent.jsx) - never loaded upfront.
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const CONSENT_KEY = "blf_cookie_consent";

let gaLoaded = false;

export function getConsent() {
  return localStorage.getItem(CONSENT_KEY);
}

export function loadGoogleAnalytics() {
  if (gaLoaded || !GA_ID || typeof window === "undefined") return;
  gaLoaded = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  // anonymize_ip: IP anonymization is a standard GDPR best practice for EU visitors.
  window.gtag("config", GA_ID, { anonymize_ip: true, send_page_view: false });
}

export function setConsent(value) {
  localStorage.setItem(CONSENT_KEY, value);
  if (value === "accepted") loadGoogleAnalytics();
}

export function initAnalyticsIfConsented() {
  if (getConsent() === "accepted") loadGoogleAnalytics();
}

export function trackPageview(path) {
  if (!gaLoaded || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", { page_path: path });
}
